import IconFont from '@/components/iconfont'
import SelectTree from '@/components/select-tree'
import Select from './remote-search'
import DatePicker from './datePicker'
import {Input} from 'iview'
import DropDownTree from '@/components/dropdown-tree'
import {isIE, timeFormat, assert} from '@/utils'
import { debounce } from 'lodash'
let isIEDes = isIE()
Input.methods.handleClear = function (event) {
  const e = { target: { value: '' } }
  this.$emit('input', '')
  this.setCurrentValue('')
  this.$emit('on-change', e, event)
}
const endtime = 24 * 60 * 60 * 1000 - 1000
function searchList (val, key, searchKey) {
  this.searchKeyMap[searchKey] = val
  this.tableModal[key] = val
}
function searchRes (cb) {
  this.currentPage = 1
  this.$emit('on-search-before', this.searchKeyMap)
  if (this.searchInterceptor) {
    this.getList(this.searchKeyMap)
      .then((res) => {
        return this.interceptor.response.resolve(res, true)
      })
      .then(({data}) => {
        this.count = 1
        this.total = data.count
        this.data = data.data
        this.$el.querySelector('.ivu-table-tip').querySelector('span').innerHTML = '暂无筛选结果'
        this.$el.querySelector('.ivu-table-tip').style.display = data.data.length ? 'none' : 'block'
        this.$el.classList[data.data.length ? 'remove' : 'add']('iv-transform-search-tip')
        // if (!data.data.length) {
        //   let headerHeight = document.querySelector('.ivu-table-header').getBoundingClientRect().height
        //   this.$el.querySelector('.ivu-table-tip').style.top = headerHeight + 57 + 'px'
        // }
        this.data.unshift({...this.tableModal, _disabled: true})
        // this.data.unshift({...this.tableModal, ...this.getSearchRow()})
        this.loading = false
        this.$emit('on-search-after', data)
        this.$emit('on-list', this.data, data, (visitor) => {
          if (typeof visitor !== 'function') return
          this.data.forEach(item => {
            if (!visitor(item)) item._disabled = true
          })
        })
      })
      .finally(() => {
        cb && cb()
      })
  } else {
    this.getList(this.searchKeyMap).then(({data}) => {
      this.count = 1
      this.total = data.count
      this.data = data.data
      this.$el.querySelector('.ivu-table-tip').querySelector('span').innerHTML = '暂无筛选结果'
      this.$el.querySelector('.ivu-table-tip').style.display = data.data.length ? 'none' : 'block'
      this.$el.classList[data.data.length ? 'remove' : 'add']('iv-transform-search-tip')
      // if (!data.data.length) {
      //   let headerHeight = document.querySelector('.ivu-table-header').getBoundingClientRect().height
      //   this.$el.querySelector('.ivu-table-tip').style.top = headerHeight + 57 + 'px'
      // }
      this.data.unshift({...this.tableModal, _disabled: true})
      // this.data.unshift({...this.tableModal, ...this.getSearchRow()})
      this.loading = false
      this.$emit('on-search-after', data)
      this.$emit('on-list', this.data, data, (visitor) => {
        if (typeof visitor !== 'function') return
        this.data.forEach(item => {
          if (!visitor(item)) item._disabled = true
        })
      })
    }).finally(() => {
      cb && cb()
    })
  }
}

// function createNoDataDom () {
//   let tbody = this.$el.querySelector('.ivu-table-overflowX').querySelector('table').querySelector('.ivu-table-tbody')
//   let tr = document.createElement('tr')
//   let td = document.createElement('td')
//   let span = document.createElement('span')
//   span.innerHTML = '暂无筛选结果'
//   tr.setAttribute('draggable', false)
//   tr.setAttribute('class', 'ivu-table-row')
//   td.setAttribute('style', `width: ${tbody.offsetWidth}px;display: block;text-align: center;line-height: 48px;`)
//   td.appendChild(span)
//   tr.appendChild(td)
//   tbody.appendChild(tr)
// }
let DateKey = 'Y'
export default function (c, params) {
  const sendSearch = debounce(searchRes.bind(this), 200)
  //const sendSearch = searchRes.bind(this)
  const search = searchList.bind(this)
  let cacheVal = params.row[params.column.key]
  //const {row} = params
  /* eslint-disable */
  const h = c
  const {
    _index,
    showType,
    searchOptionList,
    optionList,
    isOperate,
    //searchKey,
    key,
    immediateSearch,
    props,
    inputIcon,
    noSearch,
    config = {},
    optionListKey,
    handler,
    drag} = params.column;
    let searchKey = params.column.searchKey || key
    let placeholder = params.column.placeholder || '请进行模糊查询'
  const reduceSearch = async (val) => {
    await typeof val === 'function' ? val(key, searchKey) : search(val, key, searchKey)
    await (this.currentPage = 1)
    await sendSearch()
  }
  // 点击树节点切换表格数据时获取之前的搜索数据并再次显示
  if (searchKey && (this.$attrs.listData || {})[searchKey]) {
    if (!this.data[0][key]) {
      let value = this.$attrs.listData[searchKey]
      this.$set(this.data[0], key, value)
    }
  }
  const createInput = () => {
    const input = c('Input', {
      [$field]: NaN,
      props: {
        placeholder: placeholder,
        clearable: true,
        value: cacheVal
      },
      // nativeOn: {
      //   'change': (val) => {
      //     search(val.target.value, key, searchKey)
      //   },
      // },
      on: {
        'on-change': ({target}, clearEvent = {}) => {
          // 如果是ie浏览器，我们要在第一次触发时候禁止搜索
          let {value} = target
          if (isIEDes) {
            let clearTarget = clearEvent.target
            if (!(target.$$placeholder || (clearTarget && clearTarget.classList.contains('ivu-input-icon-clear')))) {
              target.$$placeholder = true
              return
            }
          }
          if (value) {
            search(value, key, searchKey)
          } else {
            // 自动更新时将触发blur的flag重置为true
            this.$$resetOperator = true
            // 没有值 代表清空操作
            search(value, key, searchKey)
            sendSearch()
          }
        },
        'on-enter': (val) => {
          // 回车时将触发blur的flag重置为true
          this.$$resetOperator = true
          sendSearch()
        },
        'on-focus': ({target}) => {
          // 获取焦点时将触发blur的flag重置为false
          this.$$resetOperator = false
          if (!isIEDes) return
          target.$$placeholder = false
        },
        'on-blur': (e) => {
          // 延迟触发，防止与重置冲突
          setTimeout(() => {
            if (this.$$resetOperator) return
            reduceSearch(e.target.value)
          })
        }
      },
      class: 'uit-table-input-form'
    })
    let btn
    if (inputIcon) {
      btn = c(IconFont, {
        props: {
          type: inputIcon.type
        },
        on: {
          click: ($event) => {
            inputIcon.handler && inputIcon.handler(params, $event)
          }
        }
      })
    }
    if (immediateSearch) {
      setTimeout(() => {
        search(cacheVal, key, searchKey)
      })
    }
    return c('div', {
      class: `iv-table-search-form${btn ? ' input-btn' : ''}`
    }, [input, btn])
  }
  const createSelect = () => {
    return c(Select, {
      props: {
        value: cacheVal || '',
        clearable: true,
        searchOptionList,
        optionList,
        props
      },
      on: {
        'on-change' (val) {
          reduceSearch(val)
        },
        'on-clear' () {
          reduceSearch('')
        }
      },
      class: 'iv-table-search-form uit-table-search-form'
    })
  }
  const createDropDownTree = () => {
    return c(DropDownTree, {
      props: {
        value: cacheVal || '',
        ...props
      },
      on: {
        'on-change'(val) {
          reduceSearch(val)
        },
        'on-clear'() {
          reduceSearch('')
        }
      },
      class: 'iv-table-search-form uit-table-search-form'
    })
  }
  const createOperate = () => {
    return c('ul', {
      class: 'iv-operate-wrapper'
    }, [
      // c('li', {
      //   class: 'iv-fs-14 iv-operate-item iv-pull-left iv-main-color iv-main-hover-color iv-pointer uit-inline-search',
      //   on: {
      //     click: () => {
      //       this.currentPage = 1
      //       sendSearch()
      //     }
      //   }
      // }, '搜索'),
      c('li', {
        class: 'iv-fs-14 iv-operate-item iv-pull-left iv-main-color iv-main-hover-color iv-pointer uit-inline-rest-search',
        on: {
          click: () => {
            this.$$resetOperator = true
            DateKey = DateKey === 'Y' ? 'N' : 'Y'
            for (let item in this.searchKeyMap) {
              this.searchKeyMap[item] = ''
            }
            this.currentPage = 1
            this.tableModal = {}
            this.forceRender()
            sendSearch(() => {
              setTimeout(() => {
                this.$$resetOperator = false
              }, 0)
            })
          }
        }
      }, '重置查询条件')
    ])
  }
  const createDatePicker = () => {
    let dateVal = Array.isArray(cacheVal) ? cacheVal : [cacheVal],
      validate = dateVal.every(date => (date || '').toString() !== 'Invalid Date')
    if (!validate) cacheVal = ''
    return c(DatePicker, {
      props: {
        value: cacheVal || '',
        props
      },
      [$field]: DateKey,
      on: {
        'on-ok': (val) => {
          reduceSearch(async (key, searchKey) => {
            // 判断是否为双层重置结构
            if (!config.searchKeyMap) {
              val = val.length ? val.map(item => timeFormat(item, config.format || 'yyyy-MM-dd HH:mm:ss')) : timeFormat(val, config.format || 'yyyy-MM-dd HH:mm:ss')
              this.searchKeyMap[searchKey] = val
              this.tableModal[key] = val
              return
            }
            let [startVal, endDVal] = (val || []), [startDate, endDate] = config.searchKeyMap
            await assert(startDate && endDate, `表格搜索配置中，范围搜索必须配置搜索字段名称`)
            await (this.searchKeyMap[startDate] = timeFormat(
              startVal,
              config.format || "yyyy-MM-dd"
            ))
            await (this.searchKeyMap[endDate] = timeFormat(
              config.format === "yyyy-MM-dd HH:mm:ss"
                ? endDVal - 0 + endtime
                : endDVal,
              config.format || "yyyy-MM-dd"
            ))
            this.tableModal[key] = [new Date(this.searchKeyMap[startDate]), new Date(this.searchKeyMap[endDate])]
          })
        },
        'on-clear': () => {
          reduceSearch(async (key, searchKey) => {
            // 判断是否为双层重置结构
            if (!config.searchKeyMap) {
              this.searchKeyMap[searchKey] = ''
              this.tableModal[key] = ''
              return
            }
            let [startDate, endDate] = config.searchKeyMap
            await assert(startDate && endDate, `表格搜索配置中，范围搜索必须配置搜索字段名称`)
            this.searchKeyMap[endDate] = this.searchKeyMap[startDate] = ''
            this.tableModal[key] = []
          })
        }
      },
      class: 'uit-table-datePicker-form'
    })
  }
  const createSearchIcon = () => {
    return c('Icon', {
      props: {
        type: 'search'
      },
      class: 'iv-fs-20'
    })
  }
  const createSearchTree = () => {
    return c(SelectTree, {
      props: {
        clearable: true,
        value: cacheVal || [],
        optionData: optionList,
        treeUrl: params.column.treeUrl,
        props
      },
      on: {
        'on-change': val => {
          const _cacheVal = cacheVal || []
          if (!val.length || val.length !== _cacheVal.length || !val.every(v => _cacheVal.includes(v))) {
            return reduceSearch(val)
          }
        }
      },
      class: 'uit-table-selectTree-form'
    })
  }
  if (noSearch) {
    if (_index === 0) {
      return createSearchIcon()
    }
    return
  }
  if (drag) {
    return createSearchIcon()
  }
  if (isOperate) {
    return createOperate()
  }
  if (!showType || showType === 'input' || showType === 'headImg') {
    return createInput()
  }
  if (showType === 'select') {
    return createSelect()
  }
  if (showType === 'dropDownTree') {
    return createDropDownTree()
  }
  if (showType === 'datePicker') {
    return createDatePicker()
  }
  if (showType === 'searchTree') {
    return createSearchTree()
  }
}
